export class SupportRoutes
{
    static Home = "/";
    // Ticket
    static TicketList: string = `/ticket/list`;
    static TicketNew: string = `/ticket/new`;
    static TicketCopy(id: string)
    {
        return `/ticket/${id}/new`;
    }
    static TicketView(id: string)
    {
        return `/ticket/${id}/view`;
    }
    // Category
    static CategoryList: string = `/category/list`;
    static CategoryView(id: string)
    {
        return `/category/${id}/view`;
    }
}